<template>
  <ProgressCircular v-if="loading" />
  <form v-else novalidate :disabled="disabled" @submit.prevent="() => {}">
    <v-row no-gutters>
      <v-col cols="8">
        <v-card max-width="1200px" flat color="transparent">
          <v-card-title>
            <FormHeader
              :loading="loading"
              :disabled="disabled"
              link="page-legal-details"
              title="Редактировать анкету юр. лица"
            />
          </v-card-title>
          <v-card-text>
            <PageContent height="90">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <span>Форма предприятия*</span>
                    <v-text-field
                      v-model="fields.orgType"
                      outlined
                      id="orgType"
                      :value="''"
                      :autofocus="!fields.orgType"
                      :error-messages="validationErrors.orgType"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.orgType.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Название организации*</span>
                    <v-text-field
                      v-model="fields.title"
                      outlined
                      id="title"
                      :value="''"
                      :autofocus="!fields.title"
                      :error-messages="validationErrors.title"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.title.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Фамилия*</span>
                    <v-text-field
                      v-model="fields.surname"
                      outlined
                      id="surname"
                      :value="''"
                      :autofocus="!fields.surname"
                      :error-messages="validationErrors.surname"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.title.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Имя*</span>
                    <v-text-field
                      v-model="fields.name"
                      outlined
                      :value="''"
                      id="name"
                      :autofocus="!fields.name"
                      :error-messages="validationErrors.name"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.name.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Отчество</span>
                    <v-text-field
                      v-model="fields.patronymic"
                      outlined
                      :value="''"
                      :autofocus="!fields.patronymic"
                      :error-messages="validationErrors.patronymic"
                      :loading="loading"
                      :disabled="disabled"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Должность</span>
                    <v-text-field
                      v-model="fields.position"
                      outlined
                      :value="''"
                      :autofocus="!fields.position"
                      :error-messages="validationErrors.position"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.position.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Номер телефона для связи*</span>
                    <v-text-field
                      v-model="fields.phone"
                      outlined
                      id="phone"
                      :value="''"
                      :autofocus="!fields.phone"
                      :error-messages="validationErrors.phone"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.phone.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Эл.почта*</span>
                    <v-text-field
                      v-model="fields.email"
                      outlined
                      id="email"
                      :value="''"
                      :autofocus="!fields.email"
                      :error-messages="validationErrors.email"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.email.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>ИНН организации*</span>
                    <v-text-field
                      v-model="fields.inn"
                      outlined
                      id="inn"
                      :value="''"
                      :autofocus="!fields.inn"
                      :error-messages="validationErrors.inn"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.inn.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>ОГРН (ОГРНИП)</span>
                    <v-text-field
                      v-model="fields.ogrn"
                      outlined
                      :value="''"
                      :autofocus="!fields.ogrn"
                      :error-messages="validationErrors.ogrn"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.ogrn.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Юридический адрес</span>
                    <v-textarea
                      v-model="fields.legalAddress"
                      outlined
                      :value="''"
                      :autofocus="!fields.legalAddress"
                      :error-messages="validationErrors.legalAddress"
                      :loading="loading"
                      :disabled="disabled"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Почтовый адрес</span>
                    <v-text-field
                      v-model="fields.mailAddress"
                      outlined
                      :value="''"
                      :autofocus="!fields.mailAddress"
                      :error-messages="validationErrors.mailAddress"
                      :loading="loading"
                      :disabled="disabled"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Банк</span>
                    <v-text-field
                      v-model="fields.bank"
                      outlined
                      :value="''"
                      :autofocus="!fields.bank"
                      :error-messages="validationErrors.bank"
                      :loading="loading"
                      :disabled="disabled"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Расчетный счет</span>
                    <v-text-field
                      v-model="fields.checkingAcc"
                      outlined
                      :value="''"
                      :autofocus="!fields.checkingAcc"
                      :error-messages="validationErrors.checkingAcc"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.checkingAcc.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>БИК банка</span>
                    <v-text-field
                      v-model="fields.bic"
                      outlined
                      :value="''"
                      :autofocus="!fields.bic"
                      :error-messages="validationErrors.bic"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.bic.$touch()"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </PageContent>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <ManageSidePanel
          ref="manageSidePanel"
          :isLocales="false"
          :is-new="false"
          :created-at="data.createdAt"
          :updated-at="data.updatedAt"
          :is-loading="loading"
          :is-submit-disabled="disabled"
          :entity-id="data.id"
          :entity-type="'legalDetail'"
          @delete="$emit('delete-detail')"
          @cancel="$router.push({ name: 'page-legal-details' })"
          @submit="submit"
        />
      </v-col>
    </v-row>
  </form>
</template>

<script>
import FormAbstract from '@/components/abstract/form'
import ManageSidePanel from '@/components/manage-side-panel/ManageSidePanel'
import FormHeader from '@/components/form-header/FormHeader'
import validationRules from './validation-rules'
import PageContent from '@/components/page-content/PageContent.vue'
import ProgressCircular from '@/components/progress-circular'

export default {
  name: 'FormLegalDetail',
  validationRules,
  components: { PageContent, FormHeader, ManageSidePanel, ProgressCircular },
  extends: FormAbstract,
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      legalDetail: {
        title: null,
        orgType: null,
        surname: null,
        name: null,
        patronymic: null,
        position: null,
        phone: null,
        email: null,
        inn: null,
        ogrn: null,
        bank: null,
        mailAddress: null,
        legalAddress: null,
        bic: null,
        checkingAcc: null
      },
      fields: {
        title: null,
        orgType: null,
        surname: null,
        name: null,
        patronymic: null,
        position: null,
        phone: null,
        email: null,
        inn: null,
        ogrn: null,
        bank: null,
        mailAddress: null,
        legalAddress: null,
        bic: null,
        checkingAcc: null
      }
    }
  },
  watch: {
    data (data) {
      this.populate(data)
      this.legalDetail = data.legalDetail
    }
  },
  methods: {
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      const payload = {
        ...this.composeFormData(this.fields)
      }
      delete payload.roles
      this.$emit('submit', payload)
    }
  }
}
</script>
